import { createFileRoute } from "@tanstack/react-router";
import { NativeEntityKanbanView } from "~/components/NativeEntityKanbanView";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/clients/view/$viewName")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, viewName } = Route.useParams();
  return (
    <NativeEntityKanbanView
      entityType="recruitment_clients"
      datasetSlug={datasetSlug}
      viewName={viewName}
    />
  );
}
